import { useTranslation } from 'react-i18next';
import LoadingPanel from 'src/components/LoadingPanel';
import Navbar from 'src/components/NavBar';
import useWindowSize from 'src/hooks/useWindowSize';
import { useContextSelector } from 'use-context-selector';
import SearchProductFilters from './SearchProductFilters';
import ToggleSearchProductView from './ToggleSearchProductView';
import { getShowSearchResultsContent } from './searchProductContext.utils';
import { SearchProductQueryContext } from './SearchProductQueryContext';
import 'src/style/search-products/SearchProductPageLayout.scss';

const SearchProductPageLayout = () => {
  const { t } = useTranslation();
  const { height } = useWindowSize();

  const searchTerm = useContextSelector(SearchProductQueryContext, (context) => context.searchTerm);
  const showNoResults = useContextSelector(
    SearchProductQueryContext,
    (context) => context.hasNoPrimarySearchResults
  );
  const isPrimarySearchPending = useContextSelector(
    SearchProductQueryContext,
    (context) => context.isPrimarySearchPending
  );
  const showSearchResultsContent = getShowSearchResultsContent(
    showNoResults,
    isPrimarySearchPending
  );

  return (
    <div
      className={`search-product-layout${showNoResults ? ' search-product-layout--no-results' : ''}`}
      style={{ height: `${height}px` }}
    >
      <div className="mb-2 min-h-0 bg-white" style={{ gridArea: 'navbar' }}>
        <div className="[&_p]:!text-[17px]">
          <Navbar title={t('searchResults')} />
        </div>
        {showNoResults ? (
          <div className="px-4 py-2">
            <p className="text-sm font-semibold">
              {t('searchResultsNoResultsFoundFor', { searchTerm: searchTerm.trim() })}
            </p>
          </div>
        ) : showSearchResultsContent ? (
          <SearchProductFilters />
        ) : null}
      </div>
      {isPrimarySearchPending && (
        <div className="relative h-full min-h-0" style={{ gridArea: 'main' }}>
          <LoadingPanel />
        </div>
      )}
      {showSearchResultsContent && <ToggleSearchProductView />}
    </div>
  );
};

export default SearchProductPageLayout;
